import Swiper from "swiper";
import { Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".content-carousel__swiper").forEach((el) => {
    new Swiper(el, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      pagination: {
        el: el.querySelector(".content-carousel__pagination"),
        clickable: true,
      },
      breakpoints: {
        782: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  });
});